/* tslint:disable */
import { VComponent } from './vcomponent';

/**
 */
export class MyComponent {
    mine?: VComponent[];
    others?: VComponent[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/my-component.ts